function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Bold",
    enableBackground: "new 0 0 32 32",
    height: "512px",
    viewBox: "0 0 32 32",
    width: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z",
    fill: "#fff9dd",
    "data-original": "#FFF9DD",
    className: "",
    style: {
      fill: "#FFFFFF"
    },
    "data-old_color": "#fff9dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.646 11.953.02.13c-.193-.686-.716-1.215-1.379-1.408l-.014-.003c-1.247-.339-6.266-.339-6.266-.339s-5.007-.006-6.266.339c-.677.196-1.199.725-1.389 1.397l-.003.014c-.466 2.434-.469 5.358.021 7.965l-.021-.132c.193.686.716 1.215 1.379 1.408l.014.003c1.246.339 6.266.339 6.266.339s5.006 0 6.266-.339c.677-.196 1.199-.725 1.389-1.397l.003-.014c.213-1.132.334-2.434.334-3.765 0-.049 0-.098-.001-.147.001-.046.001-.1.001-.154 0-1.332-.121-2.634-.354-3.897zm-9.241 6.481v-4.862l4.178 2.435z",
    fill: "#ffd200",
    "data-original": "#FFD200",
    className: "active-path",
    style: {
      fill: "#CC4040"
    },
    "data-old_color": "#ffd200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9cac47a06245e2c277db8dc0b4a85766.svg";
export { ForwardRef as ReactComponent };